var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eb77d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,0A11,11,0,1,0,22,11,11.012,11.012,0,0,0,11,0Zm0,20.3A9.3,9.3,0,1,1,20.3,11,9.307,9.307,0,0,1,11,20.3Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.909 5.832)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M146.356,139.481h-3.394v-3.394a.849.849,0,0,0-1.7,0v3.394h-3.394a.849.849,0,1,0,0,1.7h3.394v3.394a.849.849,0,0,0,1.7,0v-3.394h3.394a.849.849,0,1,0,0-1.7Z",
    transform: "translate(-137.022 -135.238)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAdd);
export default __webpack_public_path__ + "static/media/product_add.fdb2c3b56e5527a9ed638bc550493491.svg";
export { ForwardRef as ReactComponent };